export class Constant {
  public static readonly DATE_FMT = 'dd/MM/yyyy';
  public static readonly DATE_FMT_HOUR = 'dd/MM/yyyy HH:mm';
  public static readonly DATE_FMT_FULL = 'dd/MM/yyyy h:mm a';
  public static readonly DATE_FMT_STR = 'ddMMyyyy';
  public static readonly DATE_FMT_CODE = 'ddMMyy';
  public static readonly DATE_FMT_YEAR = 'yyyy';
  public static readonly DATE_FMT_NOT_FULL = 'HH:mm dd/MM/yy';
  public static readonly MESSAGE_DELETE_SUCCESS = 'Xóa thành công';
  public static readonly MESSAGE_ADD_SUCCESS = 'Tạo mới thành công';
  public static readonly MESSAGE_SERVICE_ERROR = 'Lỗi dữ liệu';
  public static readonly MESSAGE_UPDATE_SUCCESS = 'Cập nhật thành công';
  public static readonly SUCCESS = 'success';
  public static readonly WAREHOUSE_ID = 'selected_warehouse_id';
  public static readonly WAREHOUSE_MASTER = 'is_warehouse_master';
  public static readonly ERROR = 'error';
  public static readonly WARNING = 'warning';
  public static readonly TOKEN = 'token';
  public static readonly ACTION = 'action';
  public static readonly USER_INFO = 'user';
  public static readonly LOGIN_FAIL = 'Incorrect username and/or password.';
  public static readonly DELETE = 'Xóa';
  public static readonly CREATE = 'Thêm';
  public static readonly UPDATE = 'Sửa';
  public static readonly ADMIN_DASHBOARD = 'admin';
  public static readonly DOCTOR_DASHBOARD = 'doctor';
  public static readonly PORTAL_DASHBOARD = '/dashboard';
  public static readonly CSC_DASHBOARD = '/csc/dashboard';
  public static readonly PHONG = 'phong';
  public static readonly SIGNUP_SUCCESS = 'Sign up successfully.';
  public static readonly LOGIN = 'admin-login';
  public static readonly FIREBASE_TOKEN = 'firebase-token';

  // Route trang thông báo hết hạn license + key lưu tạm thông tin lỗi license
  // (message/remainDay/dateExpired) vào localStorage để trang đó đọc và hiển thị
  // sau khi bị điều hướng từ error.interceptor.ts (lỗi 403).
  public static readonly LICENSE_EXPIRED_ROUTE = 'license-expired';
  public static readonly LICENSE_INFO = 'license_info';

  // Các route public (khách/đối tác tra cứu kết quả), không cần khởi tạo Firebase Cloud Messaging.
  // Nhiều in-app browser (Zalo, Telegram, Messenger...) không hỗ trợ Push API/Notification API
  // => nếu gọi FCM ở các route này sẽ làm app trắng màn hình khi mở từ các app đó.
  public static readonly PUBLIC_ROUTES: string[] = ['ket-qua-test', 'ket-qua', 'tra-cuu'];

  public static readonly DON_HANG = 'donhang';
  public static readonly INIT_DATA = 'initial_data';
  public static readonly LANGUAGE = 'language';

  public static readonly ORDER_STATUS_WAITING_VERIFY = 0;
  public static readonly ORDER_STATUS_VERIFIED = 10;
  public static readonly ORDER_STATUS_PAID = 15;
  public static readonly ORDER_STATUS_READY4PICKING = 20;
  public static readonly ORDER_STATUS_PICKED = 30;
  public static readonly ORDER_STATUS_COMPLETED = 40;
  public static readonly ORDER_STATUS_CANCELLED = 50;

  public static readonly ORDER_CATEGORY_DOCUMENT = 91;
  public static readonly ORDER_CATEGORY_COMMERCIAL_SAMPLE = 32;
  public static readonly ORDER_CATEGORY_GIFT = 31;
  public static readonly ORDER_CATEGORY_SALES_OF_GOODS = 11;
  public static readonly ORDER_CATEGORY_OTHER = 991;

  public static readonly ADDITIONAL_CHARGE_ON_BASIC_CHARGE = 1;
  public static readonly ADDITIONAL_CHARGE_ON_DESTINATION = 2;
  public static readonly ADDITIONAL_CHARGE_ON_FAR_AREA = 3;

  public static readonly ADDITIONAL_CHARGE_ABSOLUTE = 1;
  public static readonly ADDITIONAL_CHARGE_RELATIVE = 2;
  public static readonly ADDITIONAL_CHARGE_WEIGHT_CHARGE = 3;

  public static readonly DISCOUNT_TYPE_ABSOLUTE = 1;
  public static readonly DISCOUNT_TYPE_RELATIVE = 2;

  public static readonly PER_ADMIN = 1;
  public static readonly PER_USER = 2;
  public static readonly PER_GROUP = 3;
  public static readonly PER_CUSTOMER_VIEW = 4;
  public static readonly PER_CUSTOMER_EDIT = 5;
  public static readonly PER_SYSTEM_CONFIG = 6;
  public static readonly PER_POINT = 7;
  public static readonly PER_POINT_ADD = 8;
  public static readonly PER_XN = 9;
  public static readonly PER_CUSTOMER = 100;
  public static readonly PER_VIEW_PRICE = 84;
  public static readonly PER_UPDATE_OUTSOURCE_PAID = 88; // Quyền cập nhật trạng thái đã thanh toán XN gửi ngoài
  public static readonly PER_UPDATE_INVOICE_STATUS = 91; // Quyền cập nhật trạng thái xuất hóa đơn

  public static readonly UNIT_TYPE = {
    Number: 0,
    Boolean: 5,
    Text: 10,
  };
  public static readonly RESULT_VALUE_LOG = {
    UPDATE_VALUE: 'Update',
    ADD_FILE: 'Add_File',
    REMOVE_FILE: 'Romove_File',
  };
  public static readonly DeliveryType = {
    SendItem: 1,
    SendSpecimen: 2,
    SendResult: 3,
  };
  public static readonly USER_ROLE_ID = {
    Admin: 1,
    UserManager: 2,
    CreateOrder: 3, // tạo phiếu
    PrintBarcode: 4,
    TakeSpecimen: 5, // lấy mẫu
    ReceiveSpecimen: 6, // nhận mẫu
    ResultTypeManager: 7,
    SystemConfiguration: 8,
    PatientManager: 9,
    CategoryManager: 10,
    SpecimenManager: 11,
    EditResultValue: 12,
    ApproveResultValue: 13,
    CancelResultValue: 14,
    ChemicalCategoryManager: 15,
    WarehouseManager: 16,
    WarehouseInventory: 17,
    Coordinator: 18,
    SampleExploitation: 19,
    Patient: 20,
    AddRequest: 21,
    SalesMan: 22,

    Request: 23,
    Delivery: 24,
    OrderList: 25,
    PrintResult: 26,
    PCRResult: 27,
    GeneralResult: 28,
    MachineResult: 29,
    DoubleTestResult: 30,
    ValidResult: 31,
    ResetDown: 32,
    ExportData: 33,
    OrderOutsource: 34,
    CancelSpecimen: 35,
    ReportSpecimen: 36,
    Calibrate: 37,
    QualityControl: 38,
    SpecimenType: 39,
    OrderTypeGroup: 40,
    OrderType: 41, // chỉ định
    Profile: 42,
    NormalRange: 43,
    ResultType: 44,
    ConsumableUnit: 45,
    Supplier: 46,
    Manufacturer: 47,
    Partner: 48,
    PartnerOutSource: 49,
    CodOrder: 50,
    MachineType: 51,
    Machine: 52,
    ConfigOrderType: 53,
    StorageSpecimen: 54,
    BarcodeSID: 55,
    ChemicalWareHourse: 56,
    AccountList: 57,
    AccountRole: 58,
    AccountGroupList: 59,
    AccountGroupRole: 60,
    ReportPatient: 61,
    ReportRequest: 62,
    ReportConsult: 63,
    Payment: 64,
    PartnerEdit: 65,
    OrderTypeEdit: 66,
    ReportOrder: 67,
    ReportRevenue: 68,
    CompanyManagerment: 69,
    ViewStatistic: 70,
    SendSpecimen: 71,
    UpdateOrderPartner: 72,
    DetailRevenue: 74,
    Valid1: 75,
    Valid2: 76,
    AdminGroupBusiness: 77,
    UpdateOrderDiscountPercent: 81,
    OnlyViewInvoicedOrder: 85
  };

  public static readonly FILTER_TYPE = {
    INPUT: 1,
    SELETECTION: 2,
    INPUT_NUMBER: 3,
    DATE_PICKER: 4,
  };
}
